import { render, staticRenderFns } from "./DetailsObjective.vue?vue&type=template&id=cffc3d1c&"
import script from "./DetailsObjective.vue?vue&type=script&lang=js&"
export * from "./DetailsObjective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports